export type MediaUrlEndpoints = {
  getFiles: string;
  upload: string;
};

export enum ViewMode {
  list = 'list',
  card = 'card',
}

export enum SelectionMode {
  select = 'select',
  upload = 'upload',
  edit = 'edit',
}

export type BaseLocalFile = {
  id: string;
  name: string;
  size: number;
  type: string;
  file: File;
  remote?: boolean;
};

export type LocalFileImage = {
  previewUrl?: string;
  width?: number;
  height?: number;
};

export type LocalFile = BaseLocalFile & LocalFileImage;

export type MediaFile = {
  id: number;
  documentId: string;
  name: string;
  alternativeText: null;
  caption: null;
  width: number;
  height: number;
  formats: MediaFileFormats;
  hash: string;
  ext: string;
  mime: string;
  size: number;
  url: string;
  previewUrl: null;
  provider: string;
  provider_metadata: null;
  createdAt: Date;
  updatedAt: Date;
  publishedAt: Date;
};

export interface MediaFileFormats {
  lg: MediaFileFormat;
  md: MediaFileFormat;
  sm: MediaFileFormat;
  thumbnail: MediaFileFormat;
}

export interface MediaFileFormat {
  ext: string;
  url: string;
  hash: string;
  mime: string;
  name: string;
  path: null;
  size: number;
  width: number;
  height: number;
  sizeInBytes: number;
}

// *****************************************************************************
// *** Native events
// *****************************************************************************
export class FileSelectedEvent extends CustomEvent<{ files: MediaFile[] }> {
  constructor(files: MediaFile[]) {
    super('file-selected', {
      detail: {
        files,
      },
    });
  }
}

export class FileGallerySelectedEvent extends CustomEvent<{
  files: MediaFile[];
}> {
  constructor(files: MediaFile[]) {
    super('file-gallery-selected', {
      detail: {
        files,
      },
    });
  }
}

export class FileGalleryUnselectedEvent extends CustomEvent<{
  files: MediaFile[];
}> {
  constructor(files: MediaFile[]) {
    super('file-gallery-unselected', {
      detail: {
        files,
      },
    });
  }
}

export class FileGallerySelectionChangedEvent extends CustomEvent<{
  files: MediaFile[];
}> {
  constructor(files: MediaFile[]) {
    super('file-gallery-selection-changed', {
      detail: {
        files,
      },
    });
  }
}
